import script from "./picture-upload-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./picture-upload-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./picture-upload-setting-ly.vue?vue&type=style&index=0&id=1f6da5bc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f6da5bc"]])

export default __exports__